import { Checkbox, Row } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onCheckAll, onSort } from '../../actions/ordersAction.js';
import { checkIsChildArr } from '../../services/helper';
import { convertDateToUTC } from './../../services/dst';
import './styles.css';
import title from './title';

class TableOrderHeader extends Component {
    renderTitle = () => {
        return title.map((item, key) => (
            <th key={key} width={item.width}>
                <div className="warp-header">
                    <div className="title-header" onClick={() => {
                        this.props.onSort({
                            column: item.key,
                            params: {
                                ...this.props.getOrderParams,
                                IsDesc: item.key === this.props.getOrderParams.OrderBy ? !this.props.getOrderParams.IsDesc : true
                            }
                        })
                    }}>{item.title}</div>
                    <div className="sort-icon" onClick={() => {
                        this.props.onSort({
                            column: item.key,
                            params: {
                                ...this.props.getOrderParams,
                                IsDesc: item.key === this.props.getOrderParams.OrderBy ? !this.props.getOrderParams.IsDesc : true
                            }
                        })
                    }}>
                        <i className="fa fa-chevron-up" aria-hidden="true" style={{
                            fontSize: '10px',
                            color: this.props.orderBy == item.key && !this.props.isDesc ? '#00b0f0' : '#595959',
                        }} />

                        <i className="fa fa-chevron-down" aria-hidden="true" style={{
                            fontSize: '10px',
                            color: this.props.orderBy == item.key && this.props.isDesc ? '#00b0f0' : '#595959',
                        }} />
                    </div>
                </div>
            </th>
        ))
    }

    render() {
        let listIdOrders = this.props.orders.map(order => order.ID)
        let isChildArr = checkIsChildArr(this.props.listIdCheckedOrders, listIdOrders)

        return (
            <Row>
                <table className="table-orders table-orders-header">
                    <thead>
                        <tr>
                            <th width="2%">
                                <Checkbox
                                    onChange={() => this.props.onCheckAll()}
                                    disabled={this.props.order_count === 0 ? true : false}
                                    checked={isChildArr}
                                />
                            </th>
                            {this.renderTitle()}
                        </tr>
                    </thead>
                </table>
            </Row>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.ordersReducer.orders,
        order_count: state.ordersReducer.order_count,
        isDesc: state.ordersReducer.isDesc,
        orderBy: state.ordersReducer.orderBy,
        listIdCheckedOrders: state.ordersReducer.listIdCheckedOrders,
        getOrderParams: {
            Status: state.ordersReducer.input_filter.status_list,
            FulfillOption: state.ordersReducer.input_filter.fulfill_option,
            Type: state.ordersReducer.input_filter.type_list,
            OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.input_filter.from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.input_filter.to + ' 23:59:59')),
            OrderBy: state.ordersReducer.orderBy,
            IsDesc: state.ordersReducer.isDesc,
            PageSize: state.ordersReducer.offset,
            Page: state.ordersReducer.current_page,
            ChannelOrderID: state.ordersReducer.input_filter.channel_order_no,
            ChannelID: state.ordersReducer.input_filter.channel,
            SelectedIds: state.ordersReducer.listIdCheckedOrders,
        },
    }

}

const mapDispatchToProps = dispatch => {
    return {
        onCheckAll: () => {
            dispatch(onCheckAll())
        },
        onSort: payload => {
            dispatch(onSort(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableOrderHeader)


// WEBPACK FOOTER //
// ./src/components/tab-menu/TableOrderHeader.js